<template>
<div>
  <div class="table-container">
    <div class="table-title">会社概要</div>
    <table class="table">
      <tbody>
        <tr v-for="(companyItems, index) in companyItems" :key=index>
          <th>{{ companyItems.title }}</th>
          <td>{{ companyItems.content }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="table-container">
    <div class="table-title">免許・許可・登録</div>
    <table class="table">
      <tbody>
        <tr v-for="(certItems, index) in certItems" :key=index>
          <th>{{ certItems.title }}</th>
          <td>{{ certItems.content }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="table-container">
    <div class="table-title">主要取引先（敬称略・50音順）</div>
    <table class="table">
      <tbody>
        <tr v-for="(partners, index) in partners" :key=index>
          <th>{{ partners.title }}</th>
          <td>{{ partners.content }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="table-container">
    <div class="table-title">加盟団体</div>
    <table class="table">
      <tbody>
        <tr v-for="(group, index) in groups" :key=index>
          <th>{{ group.title }}</th>
          <td>
            <div v-for="(content, index) in group.contents" :key=index >
              <a v-bind:href="content.url" target="_blank">{{ content.name }}</a>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      companyItems: [
        { title: '商号', content: '東栄運輸株式会社' },
        { title: '代表取締役社長', content: '添野　和良' },
        { title: '設立', content: '1967年9月28日' },
        { title: '本社', content: '埼玉県さいたま市岩槻区長宮77（代表：048-799-1211）' },
        { title: '観光バス部', content: '東京都板橋区小豆沢2-3-11（代表：03-3965-0556）' },
        { title: '資本金', content: '10,000千円' },
        { title: '年商', content: '24億9,679万円（2025年6月期）' },
        { title: '事業内容', content: '1.旅客自動車運送事業\n2.貨物自動車運送事業\n3.海運、鉄道、自動車貨物利用運送事業\n4.土木建設工事業\n5.上記1～4に関するコンサルティング業務\n6.旅行業\n7.自動車整備業、板金、塗装業\n8.一級建築士事務所\n9.古物商' },
        { title: '支店および営業所', content: '【観光バス部】\n東京営業所、車庫｜東京都板橋区小豆沢2-3-11｜電話 03-3965-0556（代表）\n横浜営業所、車庫｜神奈川県横浜市港北区新羽町1187｜電話 045-540-2710（代表）\n大宮営業所｜埼玉県さいたま市北区吉野町2-3-4\nさいたま第二営業所、車庫｜埼玉県さいたま市岩槻区長宮94｜電話 048-799-1214（代表）\n\n【貨物部】\nさいたま第一営業所、車庫｜埼玉県さいたま市岩槻区長宮77｜電話 048-799-1212（代表）\n土浦営業所、車庫｜茨城県土浦市神立東2-30-25｜電話 029-831-6654（代表）\n\n【工事部】\n資材センター｜埼玉県さいたま市岩槻区長宮102他（14,000平方m）' },
        { title: '取引銀行', content: 'みずほ銀行　大宮支店\n三菱東京UFJ銀行　越谷支社\n三井住友銀行　大宮支店\n埼玉りそな銀行　岩槻支店\n商工中金　さいたま支店\n群馬銀行　大宮支店\n八十二銀行　大宮支店\n武蔵野銀行　岩槻支店' },
        { title: '優良申告法人', content: '平成 1年 3月 29日\n平成 6年 6月 13日\n平成 10年 11月 18日\n平成 16年 6月 1日\n平成 21年 6月 5日\nいずれも春日部税務署長より表敬' }
      ],
      certItems: [
        { title: '貨物自動車運送事業免許', content: '昭和 45年　2月 28日\n現在の事業許可区域：全国' },
        { title: '一般貸切旅客自動車運送事業免許', content: '昭和 62年　6月 1日\n現在の事業許可区域：東京都、埼玉県、神奈川県' },
        { title: '貨物利用運送事業登録', content: '昭和 56年　8月 7日（自動車、海運、鉄道）' },
        { title: '自動車分解整備事業認証', content: '昭和 56年　3月 30日（特定整備事業）' },
        { title: '旅行業登録', content: '昭和 62年　11月 17日\n現在の登録の有効期限：令和 11年 11月 16日' },
        { title: '一般建設業許可', content: '昭和 55年　8月 10日\n現在の登録の有効期限：令和 12年 8月 8日' },
        { title: '一級建築士事務所登録', content: '平成 19年　12月5日\n現在の登録の有効期限：令和 9年 12月 4日' },
        { title: '古物商許可', content: '平成 29年 2月 24日' }
      ],
      partners: [
        { title: '貨物部', content: 'SMCテック株式会社\n酒井重工業株式会社\n株式会社　佐藤渡辺\n世紀東急工業株式会社\n大成ロテック株式会社\n東亜道路工業株式会社\n日工株式会社\n株式会社　NIPPO\n株式会社　MECX\nNX（旧日本通運）グループ\n日立建機株式会社\n日立建機ロジテック株式会社\n株式会社　日立製作所\n株式会社　日立テクノロジーアンドサービス\nロジスティード（旧日立物流）グループ\n前澤工業株式会社' },
        { title: '工事部', content: '大林道路株式会社\n株式会社　ガイアートＴＫ\n鹿島道路株式会社\n世紀東急工業株式会社\n大成ロテック株式会社\n東亜道路工業株式会社\n常盤工業株式会社\n株式会社　NIPPO\n株式会社　MECX\n日本道路株式会社\n福田道路株式会社\nフジタ道路株式会社\n前田道路株式会社\nユナイト株式会社' },
        { title: '観光バス部', content: 'A-system\n大宮トラベル教育旅行\n小田急トラベル\nオリオンツアー\n官公庁\n近畿日本ツーリスト\nクラブツーリズム\n京王観光\nJTBグループ\nJRグループ\n大和観光興業\nタウンツーリスト\nT-LIFEホールディングス\n東武青木観光\n東武トップツアーズ\n日本旅行\n農協観光\n阪急交通社\n毎日新聞旅行\n名鉄観光サービス\n読売旅行' }
      ],
      groups: [
        { title: '団体名称',
          contents: [
            { url: 'http://www.jta.or.jp/', name: '全日本トラック協会' },
            { url: 'https://www.saitokyo.or.jp/', name: '埼玉県トラック協会' },
            { url: 'https://www.ibatokyo.or.jp/', name: '茨城県トラック協会' },
            { url: 'http://www.bus.or.jp/', name: '日本バス協会' },
            { url: 'https://www.tokyobus.or.jp/', name: '東京バス協会' },
            { url: 'https://www.saitamabus.jp/', name: '埼玉県バス協会' },
            { url: 'https://www.kanagawabus.or.jp/', name: '神奈川県バス協会' },
            { url: 'http://www.zenkousoku.com/', name: '全国高速道路建設協議会' },
            { url: 'http://www.anta.or.jp/', name: '全国旅行業協会' },
            { url: 'http://www.s-bouka.or.jp/', name: 'さいたま市防火安全協会' },
            { url: 'https://www.jaspa.or.jp/', name: '日本自動車整備振興会連合会' },
            { url: 'https://www.monet-technologies.com/consortium', name: 'Monetコンソーシアム' }
          ]
        }
      ]
    }
  }
}
</script>
<style scoped>
.table-container {
  padding: 13% 4% 7% 4%;
}
.table {
  white-space: pre-line;
}
.table td {
  width: 70%;
}
.table-title {
  color: #000000;
  font-size: 32px;
  font-weight: bold;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Corporation.vue